/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Branch } from '../../models/branch';

export interface GetBranchById$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function getBranchById(http: HttpClient, rootUrl: string, params: GetBranchById$Params, context?: HttpContext): Observable<StrictHttpResponse<Branch>> {
  const rb = new RequestBuilder(rootUrl, getBranchById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Branch>;
    })
  );
}

getBranchById.PATH = '/api/v1/branches/{id}';
